import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { DetalheTitRecbMovimentacao } from "../../../../../../types/api/financeiro/datalhar-titulos-receber";
import DisplayNotFoundInfo from "../../../../../../components/DisplayNotFindInfo";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import tratativaDeDatas from "../../../../../../helpers/tratativaDeDatas";
import { useState } from "react";

export default function DialogTableMov({
  open,
  handleClose,
  movimentacoes,
}: DialogTableMovProps) {
  const [exibirExcluidas, setExibirExcluidas] = useState(false);
  const styleTH = { fontWeight: "bold", whiteSpace: "nowrap" };

  const movimentacoesFiltradas = exibirExcluidas
    ? movimentacoes
    : movimentacoes.filter((mov) => mov.status_movimento === "A");

  const existeMov = movimentacoes.length > 0;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperDraggable}
      aria-labelledby="draggable-dialog-title"
      scroll="body"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        style={{ cursor: "move" }}
        id="draggable-dialog-title"
        fontWeight={"bold"}
      >
        Movimentações financeiras
      </DialogTitle>

      <DialogContent>
        {!existeMov && (
          <DisplayNotFoundInfo label="Nenhuma movimentação encontrada" />
        )}

        <FormControlLabel
          control={
            <Switch
              checked={exibirExcluidas}
              onChange={() => setExibirExcluidas((prev) => !prev)}
            />
          }
          label="Exibir movimentações excluídas"
          sx={{ mb: 2 }}
        />

        {existeMov && (
          <TableContainer sx={{ overflow: "auto", height: 400 }}>
            <Table size="small" aria-label="a dense table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...styleTH, minWidth: 250 }}>Tipo</TableCell>
                  <TableCell sx={styleTH}>Status</TableCell>
                  <TableCell sx={styleTH}>Data movimento</TableCell>

                  <TableCell sx={styleTH} align="right">
                    Valor movimento
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Juros
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Juros capitalizado
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Correção monetária
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Valor principal
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Valor multa
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Valor desconto
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Juros(atraso)
                  </TableCell>
                  <TableCell sx={styleTH} align="right">
                    Correção monetária(atraso)
                  </TableCell>

                  <TableCell sx={styleTH}>Conta contábil</TableCell>

                  <TableCell sx={styleTH}>Indice cálculo</TableCell>
                  <TableCell sx={styleTH}>Valor indice cálculo</TableCell>
                  <TableCell sx={styleTH}>Taxa juros</TableCell>
                  <TableCell sx={styleTH}>Nº meses</TableCell>
                  <TableCell sx={styleTH}>Taxa multa</TableCell>
                  <TableCell sx={styleTH}>Tipo baixa</TableCell>
                  <TableCell sx={styleTH}>Histórico</TableCell>
                  <TableCell sx={styleTH}>Complemento</TableCell>
                  <TableCell sx={styleTH}>Usuário</TableCell>
                  <TableCell sx={styleTH}>Data alteração</TableCell>
                  <TableCell sx={styleTH}>Nº recibo</TableCell>
                  <TableCell sx={styleTH}>Data recibo</TableCell>
                  <TableCell sx={styleTH}>Programa</TableCell>
                  <TableCell sx={styleTH}>Forma recebimento</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {movimentacoesFiltradas.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell
                      sx={{ minWidth: 260 }}
                    >{`${row.tipo_movimento} - ${row.tipo_movimento_descricao}`}</TableCell>
                    <TableCell>{row.status_movimento}</TableCell>
                    <TableCell>
                      {moment(row.data_movimento).format("DD/MM/YYYY")}
                    </TableCell>

                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_movimento)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_juros)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_juros_capitalizado)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_correcao_monetaria)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_principal)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_multa)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_desconto)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(row.valor_juros_atraso)}
                    </TableCell>
                    <TableCell align="right">
                      {formatarValorMonetario(
                        row.valor_correcao_monetaria_atraso
                      )}
                    </TableCell>

                    <TableCell>{`${row.conta_contabil} ${row.centro_custo
                      .toString()
                      .padStart(3, "0")}`}</TableCell>

                    <TableCell>{row.indice_calculo}</TableCell>
                    <TableCell>{row.valor_indice_calculo}</TableCell>
                    <TableCell>{row.taxa_juros}</TableCell>
                    <TableCell>{row.numero_meses}</TableCell>
                    <TableCell>{row.taxa_multa}</TableCell>
                    <TableCell>{row.tipo_baixa}</TableCell>
                    <TableCell>{row.historico || "-"}</TableCell>
                    <TableCell>{row.complemento || "-"}</TableCell>
                    <TableCell>{row.usuario_ultima_alteracao}</TableCell>
                    <TableCell>
                      {tratativaDeDatas(row.usuario_data_alteracao)}
                    </TableCell>
                    <TableCell>{row.numero_recibo}</TableCell>
                    <TableCell>{tratativaDeDatas(row.data_recibo)}</TableCell>
                    <TableCell>{row.programa_movimento}</TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {row.forma_recebimento
                        ? `${row.forma_recebimento.id} - ${row.forma_recebimento.nome}`
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogTableMovProps {
  open: boolean;
  handleClose: () => void;
  movimentacoes: DetalheTitRecbMovimentacao[];
}
